export default __webpack_public_path__ + "static/media/Panasonic-IQ-Katalog.292b550d.pdf";